export default {
    generalReport: {
        icon: 'file-protect',
        text: 'General Report',
        route: 'admin.classical.general.report',
        role: {
            classical: [ 'admin', 'project-manager', 'project-owner', 'inspirator', 'project-manager-client', 'project-owner-client', 'project-sponsor' ],
            paper: [ 'admin', 'mentor', 'evaluator', 'advisor' ],
            project: [ 'admin', 'mentor', 'evaluator', 'advisor' ],
            performance: [ 'admin', 'mentor', 'evaluator'],
            evaluation: [ 'admin', 'mentor', 'evaluator', 'advisor'],
        }
    },
}
